// Result: 22 Jan 2024 12:16 PM

export const attachmetDateWithTime = (timestamp: string) => {
    const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ]

    const date = new Date(parseInt(timestamp)) // Convert timestamp to milliseconds and create Date object

    const day = date.getDate()
    const month = months[date.getMonth()]
    const year = date.getFullYear()
    const hour = date.getHours() % 12 || 12 // Convert 24-hour format to 12-hour format
    const minute = date.getMinutes()
    const ampm = date.getHours() < 12 ? 'AM' : 'PM'

    const formattedDate = `${day} ${month} ${year} ${hour}:${minute
        .toString()
        .padStart(2, '0')} ${ampm}`

    return formattedDate
}
